module.exports = __webpack_public_path__ + "img/pan.7e2b5534.png";